// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__g1L7U","detailsBorder":"styles_detailsBorder__ZUt3e"};